import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import border from '@/components/border/borderType';
import warn from '@/components/border/warn';
import ring from '@/components/env-bigData/ring.vue'; // 超标因子

import trendSecond from '@/components/env-bigData/trendSecond'; // 实时水文进度图

import barType from '@/components/env-bigData/barType';
import { queryHydrologylist, queryHydrologyAnalysislist, queryHydrologyCapacitylist, queryHydrologyStagelist, queryHydrologyFlowlist, queryScreenWarn, queryWastehydrologyCurveAnalysis, queryWastehydrologyPie, queryWastDateList } from '@/api/api';
export default {
  components: {
    border: border,
    ring: ring,
    trendSecond: trendSecond,
    barType: barType,
    warn: warn
  },
  data: function data() {
    return {
      showState: true,
      flowState: true,
      waterState: true,
      storageState: true,
      showReal: true,
      showState1: true,
      flowState1: true,
      waterState1: true,
      storageState1: true,
      showReal1: true,
      data1: {},
      data2: {},
      data3: {},
      data4: {},
      data5: {},
      data6: {},
      data7: {},
      data8: {},
      radioStatu: true,
      defaultValues: 0,
      waterWarnList: []
    };
  },
  props: {
    selectId: {
      default: '0',
      type: String
    },
    selectType: {
      default: '0',
      type: String
    }
  },
  watch: {
    selectId: function selectId(val) {
      var _this = this;

      this.getRealtime(val);
      this.showRadio = false;
      this.$nextTick(function () {
        _this.showRadio = true;
        _this.defaultValues = 1;

        _this.$nextTick(function () {
          _this.getWarn(_this.defaultValues, val, _this.selectType);
        });
      }); // this.getFlow(val)
    }
  },
  created: function created() {},
  methods: {
    // 控制轮播数据
    scroll: function scroll() {
      var _this2 = this;

      setTimeout(function () {
        if (_this2.waterWarnList.length > 6) {
          _this2.waterWarnList.push(_this2.waterWarnList[0]); // 将数组的第一个元素添加到数组的


          _this2.waterWarnList.shift(); //删除数组的第一个元素

        }
      }, 500);
      setTimeout(function () {
        if (_this2.dateList.length > 14) {
          _this2.dateList.push(_this2.dateList[0]); // 将数组的第一个元素添加到数组的


          _this2.dateList.shift(); //删除数组的第一个元素

        }
      }, 500);
    },
    // 站点警报的tab切换
    changetadios: function changetadios(e) {
      this.defaultValues = e;
      if (e == 0) this.radioIndex = '';else this.radioIndex = e;
      this.getWarn(this.radioIndex, this.selectId, this.selectType); // this.getWarn(this.radioIndex,this.selectType)
    },
    //获取预警内容
    getWarn: function getWarn(category, siteId, st) {
      var _this3 = this;

      console.log(category, siteId, st);
      var params = {
        category: category,
        scope: 1,
        scopeId: siteId,
        warnStatus: 1 // current: 1,
        // size: 20

      }; // 污水站点

      queryScreenWarn(params).then(function (res) {
        if (res.success && res.result.length > 0) {
          res.result.forEach(function (item, index) {
            switch (item.category) {
              case '1':
                item.category_dictText = '数据报警';
                break;

              case '2':
                item.category_dictText = '设备报警';
                break;

              case '4':
                item.category_dictText = '离线预警';
                break;
            }
          });
          _this3.waterWarnList = res.result;
        } else {
          _this3.waterWarnList = [];
        }
      });
    },
    getDay: function getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() - 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码

      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      var hour = today.getHours();
      var minute = today.getMinutes();
      var second = today.getSeconds();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + '-' + tMonth + '-' + tDate; // return tYear + '-' + tMonth + '-' + tDate+' '+hour+':'+minute+':'+second
    },
    doHandleMonth: function doHandleMonth(month) {
      var m = month;

      if (month.toString().length == 1) {
        m = '0' + month;
      }

      return m;
    },
    // 获取站点实时数据
    getRealtime: function getRealtime(siteId) {
      var _this4 = this;

      queryWastDateList({
        scopeId: siteId,
        type: 1,
        st: 61,
        scope: 1
      }).then(function (res) {
        if (res.success) {
          _this4.showReal = false;

          _this4.$nextTick(function () {
            _this4.showReal = true;

            _this4.$nextTick(function () {
              res.result.query.factors.forEach(function (item) {
                switch (item.code) {
                  case 'b01002':
                    _this4.data1 = item;
                    break;

                  case 'b02001':
                    _this4.data2 = item;
                    break;

                  case 'b02002':
                    _this4.data3 = item;
                    break;

                  case 'b05001':
                    _this4.data4 = item;
                    break;

                  case 'b03001':
                    _this4.data5 = item;
                    break;

                  case 'b03003':
                    _this4.data6 = item;
                    break;

                  case 'b03004':
                    _this4.data7 = item;
                    break;

                  case 'b03002':
                    _this4.data8 = item;
                    break;
                }
              });

              _this4.getAnalysis(siteId);

              if (res.result && res.result.records.length > 0) {
                var data = res.result.records[0];

                _this4.$refs.bartype2.initBarChart([data.factor['b01002'].value], [_this4.data1.title + '(' + _this4.data1.unitName + ')']);

                _this4.$refs.bartype3.initBarChart([data.factor['b02001'].value, data.factor['b02002'].value, res.result.records[0].factor['b05001'].value], [_this4.data2.title + '(' + _this4.data2.unitName + ')', _this4.data3.title + '(' + _this4.data3.unitName + ')', _this4.data4.title + '(' + _this4.data4.unitName + ')']);

                _this4.$refs.bartype.initBarChart([data.factor['b03001'].value, data.factor['b03003'].value, data.factor['b03004'].value, data.factor['b03002'].value], [_this4.data5.title + '(' + _this4.data5.unitName + ')', _this4.data6.title + '(' + _this4.data6.unitName + ')', _this4.data7.title + '(' + _this4.data7.unitName + ')', _this4.data8.title + '(' + _this4.data8.unitName + ')'], 0.5);
              } else {
                _this4.$refs.bartype2.initBarChart([0], [_this4.data1.title + '(' + _this4.data1.unitName + ')']);

                _this4.$refs.bartype3.initBarChart([0, 0, 0], [_this4.data2.title + '(' + _this4.data2.unitName + ')', _this4.data3.title + '(' + _this4.data3.unitName + ')', _this4.data4.title + '(' + _this4.data4.unitName + ')']);

                _this4.$refs.bartype.initBarChart([0, 0, 0, 0], [_this4.data5.title + '(' + _this4.data5.unitName + ')', _this4.data6.title + '(' + _this4.data6.unitName + ')', _this4.data7.title + '(' + _this4.data7.unitName + ')', _this4.data8.title + '(' + _this4.data8.unitName + ')']);
              }
            });
          });
        }
      }); // queryHydrologylist({
      // 	siteId
      // }).then(res => {
      // 	if (res.success
      // 		this.showReal = false
      // 		this.$nextTick(()=>{
      // 			this.showReal = true
      // 			this.$nextTick(()=>{
      // 				if (res.result && res.result.records.length > 0) {
      // 					let data = res.result.records[0]
      // 					this.$refs.bartype2.initBarChart([data.dataCodeMap['b01002'].value], [
      // 						 '今日累计降雨量(m)'
      // 					])
      // 					this.$refs.bartype3.initBarChart([data.dataCodeMap['b02001'].value, data.dataCodeMap['b02002'].value, res.result
      // 						.records[0].dataCodeMap['b05001'].value
      // 					], ['堰上水位(m)', '水位(m)', '库容(m)'])
      // 					this.$refs.bartype.initBarChart([data.dataCodeMap['b03001'].value, data.dataCodeMap['b03003'].value, data.dataCodeMap[
      // 						'b03004'].value, data.dataCodeMap['b03002'].value], ['溢流道流量(m)', '实时入库流量(m)', '今日累计入库量(m)', '今日累计溢流量(m)'])
      // 				}else{
      // 					this.$refs.bartype2.initBarChart([0], [ '今日累计降雨量(m)'
      // 					])
      // 					this.$refs.bartype3.initBarChart([0,0,0], ['堰上水位(m)', '水位(m)', '库容(m)'])
      // 					this.$refs.bartype.initBarChart([0,0,0,0], ['溢流道流量(m)', '实时入库流量(m)', '今日累计入库量(m)', '今日累计溢流量(m)'])
      // 				}
      // 			})
      // 		})
      // 	}
      // })
    },
    // formatValue(code, title, data) {
    // 	if (data[code]['now'] != 0) {
    // 		return (((data[code][title] - data[code]['now']) * 100) / data[code]['now']) < 0 ? ('下降' + (Math.abs(((data[code][
    // 			title
    // 		] - data[code]['now']) * 100) / data[code]['now']).toFixed(2)) + '%') : ('上升' + (Math.abs(((data[code][title] -
    // 			data[code]['now']) * 100) / data[code]['now']).toFixed(2)) + '%')
    // 	} else {
    // 		return ''
    // 	}
    // },
    formatTrendValue: function formatTrendValue(value, now) {
      if (now != 0) {
        return (value - now) * 100 / now < 0 ? '下降' + Math.abs((value - now) * 100 / now).toFixed(2) + '%' : '上升' + Math.abs((value - now) * 100 / now).toFixed(2) + '%';
      } else {
        return '';
      }
    },
    // 获取流量分析数据
    // getFlow(id) {
    // 	queryWastehydrologyPie({
    // 		scopeId: id,
    // 		factorCodes: 'b03002,b03003'
    // 	}).then(res => {
    // 		if (res.success) {
    // 			this.flowState1 = false
    // 			this.$nextTick(() => {
    // 				this.flowState1 = true
    // 				this.$nextTick(() => {
    // 					let keys = Object.keys(res.result).reverse()
    // 					let data1 = res.result[keys[0]] ? (res.result[keys[0]].factor['b03002'] ? res.result[keys[0]].factor[
    // 						'b03002'].value : 0) : 0
    // 					let data2 = res.result[keys[2]] ? (res.result[keys[2]].factor['b03002'] ? res.result[keys[2]].factor[
    // 						'b03002'].value : 0) : 0
    // 					let data3 = res.result[keys[1]] ? (res.result[keys[1]].factor['b03002'] ? res.result[keys[1]].factor[
    // 						'b03002'].value : 0) : 0
    // 					let data4 = res.result[keys[0]] ? (res.result[keys[0]].factor['b03003'] ? res.result[keys[0]].factor[
    // 						'b03003'].value : 0) : 0
    // 					let data5 = res.result[keys[2]] ? (res.result[keys[2]].factor['b03003'] ? res.result[keys[2]].factor[
    // 						'b03003'].value : 0) : 0
    // 					let data6 = res.result[keys[1]] ? (res.result[keys[1]].factor['b03003'] ? res.result[keys[1]].factor[
    // 						'b03003'].value : 0) : 0
    // 					let dataStr = this.formatTrendValue(data1, data2)
    // 					let dataStr2 = this.formatTrendValue(data3, data2)
    // 					let dataStr3 = this.formatTrendValue(data4, data5)
    // 					let dataStr4 = this.formatTrendValue(data6, data5)
    // 					this.$refs.bartype4.initBarChart([data1, data2, data3], ['同比(' + dataStr + ')', '入库量', '环比(' + dataStr2 +
    // 						')'
    // 					], 1)
    // 					this.$refs.bartype5.initBarChart([data4, data5, data6], ['同比(' + dataStr3 + ')', '溢流量', '环比(' + dataStr4 +
    // 						')'
    // 					], 1)
    // 				})
    // 			})
    // 		}
    // 	})
    // 	// queryHydrologyFlowlist({
    // 	// 	id
    // 	// }).then(res => {
    // 	// 	if (res.success && res.result) {
    // 	// 		this.flowState = false
    // 	// 		this.$nextTick(()=>{
    // 	// 			this.flowState = true
    // 	// 			this.$nextTick(()=>{
    // 	// 				let data = res.result.pieFactors
    // 	// 				let dataStr = this.formatValue('b03004', 'YOY', data)
    // 	// 				let dataStr2 = this.formatValue('b03004', 'QOQ', data)
    // 	// 				let dataStr3 = this.formatValue('b03002', 'YOY', data)
    // 	// 				let dataStr4 = this.formatValue('b03002', 'QOQ', data)
    // 	// 				this.$refs.bartype4.initBarChart([data['b03004']['YOY'], data['b03004']['now'], data['b03004']['QOQ']], ['同比(' +
    // 	// 					dataStr + ')', '入库量', '环比(' + dataStr2 + ')'
    // 	// 				], 5000)
    // 	// 				this.$refs.bartype5.initBarChart([data['b03002']['YOY'], data['b03002']['now'], data['b03002']['QOQ']], ['同比(' +
    // 	// 					dataStr3 + ')', '溢流量', '环比(' + dataStr4 + ')'
    // 	// 				], 5000)
    // 	// 				let analysisData = []
    // 	// 				let analysisObj = {}
    // 	// 				let arr = []
    // 	// 				let dateArr = []
    // 	// 				if (res.result && res.result.data.length > 0) {
    // 	// 					res.result.data.forEach((item, index) => {
    // 	// 						dateArr.push(item.dateStr)
    // 	// 					})
    // 	// 					res.result.factors.forEach((item, index) => {
    // 	// 						let resArr = []
    // 	// 						res.result.data.forEach((item1, index1) => {
    // 	// 							resArr.push(item1.dataCodeMap[item.code].value.toFixed(2))
    // 	// 						})
    // 	// 						item.data = resArr
    // 	// 						return item
    // 	// 					})
    // 	// 					arr = res.result.factors
    // 	// 				}
    // 	// 				this.$refs.trendFlow.initBarChart(arr, dateArr)
    // 	// 			})
    // 	// 		})
    // 	// 	}
    // 	// })
    // },
    // formatData(res, title, code, type) {
    // 	let data = []
    // 	let obj = {}
    // 	for (let i = 0; i < 3; i++) {
    // 		obj.prevalue = res.result.pieFactors[code]['now'],
    // 			obj.hismax = 5000
    // 		obj.unit = 'm'
    // 		switch (i) {
    // 			case 0:
    // 				obj.name = '同比'
    // 				obj.value = res.result.pieFactors[code]['YOY'].toFixed(2)
    // 				break
    // 			case 1:
    // 				obj.name = title
    // 				obj.value = res.result.pieFactors[code]['now'].toFixed(2)
    // 				break
    // 			case 2:
    // 				obj.name = '环比'
    // 				obj.value = res.result.pieFactors[code]['QOQ'].toFixed(2)
    // 				break
    // 		}
    // 		data.push(obj)
    // 		obj = {}
    // 	}
    // 	let analysisData = []
    // 	let analysisObj = {}
    // 	let arr = []
    // 	let dateArr = []
    // 	if (res.result && res.result.data.length > 0) {
    // 		res.result.data.forEach((item, index) => {
    // 			analysisData.push(item.dataCodeMap[code].value.toFixed(2))
    // 			dateArr.push(item.dateStr)
    // 		})
    // 		analysisObj.title = '降雨量'
    // 		analysisObj.data = analysisData
    // 		arr.push(analysisObj)
    // 	}
    // 	switch (type) {
    // 		case 1:
    // 			this.$refs.trendRain.initBarChart(arr, dateArr)
    // 			this.$refs.ringRain.initBarChart(data)
    // 			break;
    // 		case 2:
    // 			this.$refs.trendStorage.initBarChart(arr, dateArr)
    // 			this.$refs.ringStorage.initBarChart(data)
    // 			break;
    // 		case 3:
    // 			this.$refs.trendWater.initBarChart(arr, dateArr)
    // 			this.$refs.ringWater.initBarChart(data)
    // 			break;
    // 	}
    // },
    formatValues: function formatValues(data, code, res, refs) {
      var arr = [];
      var dataArr = [];
      var dateArr = [];
      var obj = {};
      obj.title = data.title;
      res.result.records.forEach(function (item, index) {
        arr.push(item.factor[code].value != null ? item.factor[code].value : '');
        dateArr.push(item.dataTime);
      });
      obj.data = arr;
      dataArr.push(obj);
      this.$refs[refs].initBarChart(dataArr, dateArr, data.unitName);
    },
    formatRain: function formatRain(title, code, res, ref, unit) {
      // let title = '本月降雨量'
      var data = [];
      var obj = {};
      var keys = Object.keys(res.result).reverse();

      for (var i = 0; i < 3; i++) {
        obj.prevalue = res.result[keys[2]] ? res.result[keys[2]].factor[code].value.toFixed(2) : 0;
        obj.hismax = 5000;
        obj.unit = unit;

        switch (i) {
          case 0:
            obj.name = '同比';
            obj.value = res.result[keys[0]] ? res.result[keys[0]].factor[code].value.toFixed(2) : 0;
            break;

          case 1:
            obj.name = title;
            obj.value = res.result[keys[2]] ? res.result[keys[2]].factor[code].value.toFixed(2) : 0;
            break;

          case 2:
            obj.name = '环比';
            obj.value = res.result[keys[1]] ? res.result[keys[1]].factor[code].value.toFixed(2) : 0;
            break;
        }

        data.push(obj);
        obj = {};
      } // debugger


      this.$refs[ref].initBarChart(data);
    },
    // 获取各个曲线数据
    getAnalysis: function getAnalysis(id) {
      var _this5 = this;

      var dataCode = ['b01002', 'b05001', 'b02002', 'b03002'];
      queryWastehydrologyPie({
        scopeId: id,
        factorCodes: 'b01002,b05001,b02002,b03001,b03003'
      }).then(function (res) {
        if (res.success) {
          dataCode.forEach(function (item) {
            switch (item) {
              case 'b01002':
                _this5.showState1 = false;

                _this5.$nextTick(function () {
                  _this5.showState1 = true;

                  _this5.$nextTick(function () {
                    _this5.formatRain('本月累计降雨量', 'b01002', res, 'ringRain', _this5.data1.unitName); // this.formatData(res, '本月累计降雨量', 'b01002', 1)

                  });
                });

                break;

              case 'b05001':
                _this5.storageState1 = false;

                _this5.$nextTick(function () {
                  _this5.storageState1 = true;

                  _this5.$nextTick(function () {
                    _this5.formatRain('本月平均库容', 'b05001', res, 'ringStorage', _this5.data4.unitName); // this.formatData(res, '本月累计降雨量', 'b01002', 1)

                  });
                });

                break;

              case 'b02002':
                _this5.waterState1 = false;

                _this5.$nextTick(function () {
                  _this5.waterState1 = true;

                  _this5.$nextTick(function () {
                    _this5.formatRain('本月平均水位', 'b02002', res, 'ringWater', _this5.data3.unitName); // this.formatData(res, '本月累计降雨量', 'b01002', 1)

                  });
                });

                break;

              case 'b03002':
                _this5.flowState1 = false;

                _this5.$nextTick(function () {
                  _this5.flowState1 = true;

                  _this5.$nextTick(function () {
                    var keys = Object.keys(res.result).reverse();
                    var data1 = res.result[keys[0]] ? res.result[keys[0]].factor['b03003'] ? res.result[keys[0]].factor['b03003'].value : 0 : 0;
                    var data2 = res.result[keys[2]] ? res.result[keys[2]].factor['b03003'] ? res.result[keys[2]].factor['b03003'].value : 0 : 0;
                    var data3 = res.result[keys[1]] ? res.result[keys[1]].factor['b03003'] ? res.result[keys[1]].factor['b03003'].value : 0 : 0;
                    var data4 = res.result[keys[0]] ? res.result[keys[0]].factor['b03001'] ? res.result[keys[0]].factor['b03001'].value : 0 : 0;
                    var data5 = res.result[keys[2]] ? res.result[keys[2]].factor['b03001'] ? res.result[keys[2]].factor['b03001'].value : 0 : 0;
                    var data6 = res.result[keys[1]] ? res.result[keys[1]].factor['b03001'] ? res.result[keys[1]].factor['b03001'].value : 0 : 0;

                    var dataStr = _this5.formatTrendValue(data1, data2);

                    var dataStr2 = _this5.formatTrendValue(data3, data2);

                    var dataStr3 = _this5.formatTrendValue(data4, data5);

                    var dataStr4 = _this5.formatTrendValue(data6, data5);

                    _this5.$refs.bartype4.initBarChart([data1, data2, data3], ['同比(' + dataStr + ')', '入库量(' + _this5.data6.unitName + ')', '环比(' + dataStr2 + ')'], 1);

                    _this5.$refs.bartype5.initBarChart([data4, data5, data6], ['同比(' + dataStr3 + ')', '溢流量(' + _this5.data5.unitName + ')', '环比(' + dataStr4 + ')'], 1);
                  });
                });

                break;
            }
          });
        }
      }); // queryWastehydrologyPie({
      // 	scopeId: id,
      // 	factorCodes: 'b05001'
      // }).then(res => {
      // 	if (res.success) {
      // 	}
      // })
      // queryWastehydrologyPie({
      // 	scopeId: id,
      // 	factorCodes: 'b02002'
      // }).then(res => {
      // 	if (res.success) {
      // 		this.waterState1 = false
      // 		this.$nextTick(() => {
      // 			this.waterState1 = true
      // 			this.$nextTick(() => {
      // 				this.formatRain('本月平均水位', 'b02002', res, 'ringWater', this.data3.unitName)
      // 				// this.formatData(res, '本月累计降雨量', 'b01002', 1)
      // 			})
      // 		})
      // 	}
      // })
      // 降雨分析数据

      queryWastehydrologyCurveAnalysis({
        stime: this.getDay(30),
        etime: this.getDay(0),
        scopeId: id,
        type: 1,
        dataType: 12 // factorCodes: 'b01002',

      }).then(function (res) {
        if (res.success && res.result.records.length > 0) {
          dataCode.forEach(function (item) {
            switch (item) {
              case 'b01002':
                _this5.showState = false;

                _this5.$nextTick(function () {
                  _this5.showState = true;

                  _this5.$nextTick(function () {
                    _this5.formatValues(_this5.data1, 'b01002', res, 'trendRain'); // this.formatData(res, '本月累计降雨量', 'b01002', 1)

                  });
                });

                break;

              case 'b05001':
                _this5.storageState = false;

                _this5.$nextTick(function () {
                  _this5.storageState = true;

                  _this5.$nextTick(function () {
                    _this5.formatValues(_this5.data4, 'b05001', res, 'trendStorage'); // this.formatData(res, '本月累计降雨量', 'b01002', 1)

                  });
                });

                break;

              case 'b02002':
                _this5.waterState = false;

                _this5.$nextTick(function () {
                  _this5.waterState = true;

                  _this5.$nextTick(function () {
                    _this5.formatValues(_this5.data3, 'b02002', res, 'trendWater'); // this.formatData(res, '本月累计降雨量', 'b01002', 1)

                  });
                });

                break;

              case 'b03002':
                _this5.flowState = false;

                _this5.$nextTick(function () {
                  _this5.flowState = true;

                  _this5.$nextTick(function () {
                    var dateArr = [];
                    var Arr1 = [];
                    var Arr2 = [];
                    var dataArr = [];
                    res.result.records.forEach(function (item, index) {
                      dateArr.push(item.dataTime);
                      Arr1.push(item.factor['b03002'].value ? item.factor['b03002'].value : 0);
                      Arr2.push(item.factor['b03004'].value ? item.factor['b03004'].value : 0);
                    });
                    var obj1 = {};
                    var obj2 = {};
                    obj1.title = _this5.data8.title;
                    obj1.data = Arr1;
                    obj2.title = _this5.data7.title;
                    obj2.data = Arr2;
                    dataArr.push(obj1);
                    dataArr.push(obj2);

                    _this5.$refs.trendFlow.initBarChart(dataArr, dateArr); // this.formatData(res, '本月累计降雨量', 'b01002', 1)

                  });
                });

            }
          });
        }
      }); // 库容分析
      // queryWastehydrologyCurveAnalysis({
      // 	stime: this.getDay(30),
      // 	etime: this.getDay(0),
      // 	scopeId: id,
      // 	type: 1,
      // 	dataType: 12,
      // 	factorCodes: 'b05001',
      // }).then(res => {
      // 	if (res.success && res.result.records.length > 0) {
      // 	}
      // })
      // // 水位分析
      // queryWastehydrologyCurveAnalysis({
      // 	stime: this.getDay(30),
      // 	etime: this.getDay(0),
      // 	scopeId: id,
      // 	type: 1,
      // 	dataType: 12,
      // 	factorCodes: 'b02002',
      // }).then(res => {
      // 	if (res.success && res.result.records.length > 0) {
      // 		this.waterState = false
      // 		this.$nextTick(() => {
      // 			this.waterState = true
      // 			this.$nextTick(() => {
      // 				this.formatValues('降雨量', 'b02002', res, 'trendWater')
      // 				// this.formatData(res, '本月累计降雨量', 'b01002', 1)
      // 			})
      // 		})
      // 	}
      // })
      // queryWastehydrologyCurveAnalysis({
      // 	stime: this.getDay(30),
      // 	etime: this.getDay(0),
      // 	scopeId: id,
      // 	type: 1,
      // 	dataType: 12,
      // 	factorCodes: 'b01002',
      // }).then(res=>{
      // 	if (res.success && res.result.records.length>0) {
      // 		this.showState = false
      // 		this.$nextTick(() => {
      // 			this.showState = true
      // 			this.$nextTick(() => {
      // 				this.formatValues('降雨量','b01002',res)
      // 				// this.formatData(res, '本月累计降雨量', 'b01002', 1)
      // 			})
      // 		})
      // 	}
      // })
      // 注释部分
      // queryHydrologyAnalysislist({
      // 	id
      // }).then(res => {
      // 	if (res.success) {
      // 		this.showState = false
      // 		this.$nextTick(() => {
      // 			this.showState = true
      // 			this.$nextTick(() => {
      // 				this.formatData(res, '本月累计降雨量', 'b01002', 1)
      // 			})
      // 		})
      // 	}
      // })
      // 库容分析数据
      // queryHydrologyCapacitylist({
      // 	id
      // }).then(res => {
      // 	if (res.success) {
      // 		this.storageState = false
      // 		this.$nextTick(() => {
      // 			this.storageState = true
      // 			this.$nextTick(() => {
      // 				this.formatData(res, '本月平均库容', 'b05001', 2)
      // 			})
      // 		})
      // 	}
      // })
      // // 水位分析数据
      // queryHydrologyStagelist({
      // 	id
      // }).then(res => {
      // 	if (res.success) {
      // 		this.waterState = false
      // 		this.$nextTick(() => {
      // 			this.waterState = true
      // 			this.$nextTick(() => {
      // 				this.formatData(res, '本月平均水位', 'b02002', 3)
      // 			})
      // 		})
      // 	}
      // })
    }
  }
};